export function Units () {
  return {
    baseUnit: 8
  }
}

export function Colors () {
  return {
    red: '#D30014',
    gin: '#EAF3EF',
    swansDown: '#D4E6DC',
    pixieGreen: '#BFDCB2',
    springWood: '#F8F6F0',
    lightBlue: '#AEDCEA',
    potPourri: '#F7E5E2',
    peppermint: '#DAE8D0',
    deepSeaGreen: '#005260',
    catSkillWhite: '#EBF6F9',
    ecruWhite: '#F6F5E4',
    hummingBird: '#D2EFF6',
    onahau: '#BDE7F1',
    grannyApple: '#C9E6C2',
    zanah: '#DAEED5',
    hawkesBlue: '#D5DDEE',
    iceCold: '#B2DCDA'
  }
}

export function SecondaryColors () {
  return {
    luft1: '#B2DCDA',
    luft2: '#D3EAE9',
    luft3: '#7DBEBA',
    korn1: '#E6E3BB',
    korn2: '#F0EED8',
    korn3: '#CFC98B',
    dugg1: '#BEDACA',
    dugg2: '#D9E9E0',
    dugg3: '#8DB9A0',
    varme1: '#E8D1C1',
    varme2: '#F1E4DB',
    varme3: '#D1AB94',
    berg1: '#D4D5CE',
    berg2: '#E6E6E2',
    berg3: '#B0B2A5',
    nype1: '#F6B6B3',
    nype2: '#FAD5D3',
    nype3: '#EB8380',
    roslyng1: '#D2B9C8',
    roslyng2: '#ECE2E8',
    roslyng3: '#AD879E',
    sand1: '#EBE6D6',
    sand2: '#F3F0E7',
    sand3: '#D9CFB4',
    siv1: '#F0E1BD',
    siv2: '#F6EDD9',
    siv3: '#E0C58E',
    himmel1: '#AEDCEA',
    himmel2: '#D1EAF3',
    himmel3: '#7ABED3',
    lavendel1: '#BBC7E0',
    lavendel2: '#D8DEED',
    lavendel3: '#8A9CC4',
    gress1: '#C0DCB2',
    gress2: '#DBEAD3',
    gress3: '#90BC7F',
    stein1: '#B9CDD4',
    stein2: '#D7E2E6',
    stein3: '#87A5AF',
    noytral1: '#E3E3E3',
    noytral2: '#EEEEEE',
    noytral3: '#CACACA',
    mork: '#A3A3A3'
  }
}
